/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Styles from "./repayOrderModal.module.scss";
import PaymentListCard from "./paymentListCard";
import to from "await-to-js";
import { getCheckoutInfo, getPayNowInfo } from "@/app/csr-src/apis/checkout/checkout.api";
import RepayButtons from "./repayButtons";
import { useNavigate } from "react-router-dom";
import UKMaskLoading from "@/common-components-src/components/UKMaskLoading/index";
import UKToast from "@/common-components-src/components/UKToast/index";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import SafetyLoading from "./safetyLoading";
import { useTranslation } from "react-i18next";
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/26172";

interface RepayOrderModalProps {
  orderId: string;
  open: boolean;
  onClose: () => void;
  onFresh?: () => void;
}

interface PaymentMapType {
  [key: string]: string;
}

const RepayOrderModal = observer((props: RepayOrderModalProps) => {
  const { onClose } = props;
  const navigate = useNavigate();
  const { checkoutStore } = useStores();
  const { creditCardStore, browserInfo, paymentList } = checkoutStore;
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  const initData = async (
    params?: {
      disabledPayMethods: string,
      currentUserPayMethods: string
    }
  ) => {
    UKMaskLoading.show();
    const requestData = {
      orderId: props.orderId,
      buId: "405",
      extParam: params ? { ...params } : undefined
    };
    // 获取订单支付信息：支付方式列表
    const [err, res] = await to(getPayNowInfo(requestData));
    checkoutStore.setSafetyLoading(false);
    UKMaskLoading.close();
    if (!err && res?.list?.length > 0) {
      checkoutStore.setPaymentList(res.list);
      return;
    }

    onClose();
    UKToast.show({
      content: t("common.message.networkError"), // 弹窗内容
      icon: "error", // 可选：success, fail, loading, warn, info，影响图标
    });
  };

  // 支付完成
  const handlePayFinish = () => {
    setTimeout(() => {
      onClose();
      if (props.onFresh) {
        props.onFresh();
      } else {
        toOrderList();
      }
    }, 2000);
  };

  // 去订单列表
  const toOrderList = () => {
    navigate("/profile/my-orders", { replace: true });
  };

  // 支付失败
  const onSubmitError = () => {
    console.log("onSubmitError");
  };

  const getBillingAddress = async (requestData: any) => {
    // 获取账单地址、金额详情
    const [err, res] = await to(getCheckoutInfo({ ...requestData }));
    console.log(!err, res, "getBillingAddress");
    // 订单应付金额
    checkoutStore.setOrderPaymentPrice(res?.orderPriceDetail.price || "");
    checkoutStore.setLocalInfo({
      currencySymbol: res?.orderPriceDetail?.unit,
    });

    if (!err && res) {
      creditCardStore.setBillingAddress(res.billingAddress);
    }
  };
  const initBrowserInfo = () => {
    const info: any = { ...browserInfo };
    info.screenWidth = screen.width;
    info.screenHeight = screen.height;
    info.userAgent = navigator.userAgent;
    info.timeZoneOffset = String(new Date().getTimezoneOffset());
    checkoutStore.setBrowserInfo({ ...info });
  };
  useEffect(() => {
    checkoutStore.setPaymentList([]);
    initData({
      disabledPayMethods: checkoutStore.disabledPayMethods.join(','),
      currentUserPayMethods: ""
    });
    initBrowserInfo();
    const maskLoadingElement = document.getElementById("loading-mask");
    maskLoadingElement.setAttribute("style", "z-index: 1000000");
  }, []);

  useEffect(() => {
    checkoutStore.setRepayOrderId(props.orderId);

    if (props.orderId) {
      const requestData = {
        orderId: props.orderId,
      };
      // 获取账单地址
      getBillingAddress(requestData);
    }
  }, [props.orderId]);

  useEffect(() => {
    setIsOpen(props.open);
    // 初始化信用卡表单
    creditCardStore.initCreditForm();
    checkoutStore.setSafetyLoading(false);
  }, [props.open]);

  // 支付方式切换点击埋点
  const paymentTrackAction = (params: { payWay: string, channelName: string }) => {
    sendClickTrack.Cashier_Pop_PayWay({ ...params, orderId: props.orderId });
  }

  return (
    <>
      {(paymentList as any[]).length ? (
        <UKDialog
          open={isOpen}
          onClose={() => {
            props.onClose();
          }}
          showCloseBtn={true}
          className={Styles.repayOrderModal}
          sx={{
            "& .MuiDialog-paper": {
              width: "620px", // 设置自定义宽度
              maxWidth: "none", // 取消最大宽度限制
              maxHeight: "428px",
              minHeight: "300px",
            },
          }}
        >
          <DialogTitle className={Styles.repayOrderModalTitle}>
            {t("checkout.payMethod.title")}
          </DialogTitle>
          <DialogContent>
            <div exptag={"exp|" + EXPOSURE_RECORD.Cashier_Pop_Expo}
              data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
              data-exptag-json-param={JSON.stringify({ orderId: props.orderId || "-100" })}>
              <PaymentListCard
                isHideTitle={true}
                className={Styles.repayOrderPaymentCard}
                onTrack={paymentTrackAction}
                onFresh={initData}
              />
            </div>

          </DialogContent>
          <DialogActions className={Styles.repayOrderModalFooter}>
            <RepayButtons onSubmitError={onSubmitError} onFinish={handlePayFinish}
              onFresh={initData} onClose={props.onClose}
            />
          </DialogActions>

          {checkoutStore.safetyLoading && <SafetyLoading />}
        </UKDialog>
      ) : null}
    </>
  );
});

export default RepayOrderModal;
